import { MutableRefObject, ReactNode, useEffect, useRef } from "react";
import Flex from "../Flex/Flex"
import Button from "../forms/Button/Button";
import IconPlus from "../icons/IconPlus";
import IconMinus from "../icons/IconMinus";
import { IconArrowDown, IconArrowUp } from "../icons/IconArrow";
import useAccordion from "@/hooks/useAccordion";

import styles from "./Accordion.module.css";


export interface AccordionProps {
  title?: ReactNode;
  children?: React.ReactNode;
  defaultExpanded?: boolean;
  onCollapseChange?: (collapsed: boolean, ref: MutableRefObject<HTMLDivElement>) => void;
  setOverflowOnExpanded?: boolean;
  saveCollapsedStateInSessionStorage?: string; // string is the name you want to use for the key in local storage.
}

export default function Accordion(props: AccordionProps) {
  const { children, title = "Accordion Title", defaultExpanded = false, onCollapseChange, setOverflowOnExpanded, saveCollapsedStateInSessionStorage } = props;
  const accordionRef = useRef<HTMLDivElement>();
  let _defaultExpanded = defaultExpanded;
  if (saveCollapsedStateInSessionStorage) {
    const storedState = window.sessionStorage.getItem(saveCollapsedStateInSessionStorage);
    if (storedState === "true") {
      _defaultExpanded = false;
    } else if (storedState === "false") {
      _defaultExpanded = true;
    } // no else, because if it's omitted, we want to use the value of 'default expanded'
  }
  const { collapsed, setCollapsed } = useAccordion(accordionRef, !_defaultExpanded, "0px");

  useEffect(() => {
    if (setOverflowOnExpanded && !collapsed && !!accordionRef.current) {
      accordionRef.current.style.overflow = "visible";
    }
  }, [accordionRef, collapsed]);

  return (
    <>
      <div
        className={styles.heading}
        onClick={() => {
          onCollapseChange?.(!collapsed, accordionRef);
          setCollapsed(!collapsed);
          if (saveCollapsedStateInSessionStorage) {
            window.sessionStorage.setItem(saveCollapsedStateInSessionStorage, !collapsed ? "true" : "false");
          }
        }}
      >
        <Flex justify="space-between" align="center">
          {typeof title === "string" ? <h3 className={`small-heading`}>{title}</h3> : title}
          <Button 
            type="text"
            style={{ background: "none" }}
          >
            {collapsed ? <IconArrowDown/> : <IconArrowUp/>}
          </Button>
        </Flex>
      </div>

      <div
        ref={accordionRef}
        className={styles.content}
      >
        {children}
      </div>
    </>
  );
}
